import { uniqueId } from 'lodash';
var makeAvails = function makeAvails(length) {
  return Array.from({
    length: length
  }).map(function () {
    return "avails-".concat(uniqueId());
  });
};
var makeGroupProvider = function makeGroupProvider(length) {
  return Array.from({
    length: length
  }).map(function () {
    return {
      providerKey: "provider-".concat(uniqueId()),
      availabilities: makeAvails(10)
    };
  });
};
var makeFacilityGroup = function makeFacilityGroup(length) {
  return Array.from({
    length: length
  }).map(function () {
    return {
      facilityKey: "facility-".concat(uniqueId()),
      group: makeGroupProvider(3)
    };
  });
};
var makeDateGroup = function makeDateGroup(length) {
  return Array.from({
    length: length
  }).map(function () {
    return {
      dateKey: "date-".concat(uniqueId()),
      group: makeFacilityGroup(1)
    };
  });
};
export default function makeMockData() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return makeDateGroup(length);
}